import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

function UnlinkConfirmDialog({ open, onClose, onConfirm, loading }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unlink-dialog-title"
      aria-describedby="unlink-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle id="unlink-dialog-title">Remove Link?</DialogTitle>
      <DialogContent>
        <DialogContentText id="unlink-dialog-description">
          Are you sure you want to remove this link? This will immediately revoke access to all shared collections.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          data-testid="unlink-confirm-remove"
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnlinkConfirmDialog;
